import { useTimeseriesQuery, computeGranularity, type TimeSeriesResult } from './useTimeseriesQuery';
import { queryKeys } from '@/lib/query-keys';
import type { Granularity } from '@/lib/analytics/metrics';

interface UseCallsSeriesArgs {
  workspaceId: string;
  from: Date;
  to: Date;
  compareFrom: Date | null;
  compareTo: Date | null;
  manualGranularity: 'auto' | Granularity;
  userFilter: string | null;
  tz: string;
  outcomeFilter?: string[];
  enabled?: boolean;
}

export function useCallsSeries(opts: UseCallsSeriesArgs): TimeSeriesResult {
  const granularity = computeGranularity(opts.from, opts.to, opts.manualGranularity);
  const fromIso = opts.from.toISOString();
  const toIso = opts.to.toISOString();
  return useTimeseriesQuery({
    rpcName: 'get_calls_series',
    args: {
      p_workspace_id: opts.workspaceId,
      p_from: fromIso,
      p_to: toIso,
      p_compare_from: opts.compareFrom?.toISOString() ?? null,
      p_compare_to: opts.compareTo?.toISOString() ?? null,
      p_granularity: granularity,
      p_user_filter: opts.userFilter,
      p_tz: opts.tz,
      p_outcome_filter: opts.outcomeFilter ?? null,
    },
    queryKey: queryKeys.analytics.series(
      opts.workspaceId,
      'calls',
      fromIso,
      toIso,
      granularity,
      opts.userFilter,
      { outcomes: opts.outcomeFilter ?? [] },
    ),
    from: opts.from,
    to: opts.to,
    compareFrom: opts.compareFrom,
    compareTo: opts.compareTo,
    granularity,
    enabled: opts.enabled,
  });
}
